import { z } from 'zod'
export const internDetailsSearchSchema = z.object({
  tab: z.enum(['diary', 'info', 'agreements']).catch('diary'),
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z
    .enum(['date', 'intern', 'programitem', 'org', 'time', 'academichours', 'grade'])
    .catch('date'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})
export type InternDetailsSearch = z.infer<typeof internDetailsSearchSchema>
export const toInternDetailsTab = (value: string | null): InternDetailsSearch['tab'] =>
  internDetailsSearchSchema.shape.tab.parse(value)
export const defaultInternDetailsSearch = internDetailsSearchSchema.parse({})
export const internDetailsRequest = (id: string, search: InternDetailsSearch) => ({
  id,
  page: search.page,
  pageSize: search.pageSize,
  sortBy: `${search.sortBy}${search.direction === 'desc' ? '-' : ''}`,
})
